import { isLogin } from "app/_helpers/helper";
import React from "react";
import { Route, Redirect } from "react-router-dom";

const PublicRoute = ({ component: Component, isPublic = false, ...rest }) => {
  const url = window.location.href.includes("mobile") ? "/mobile/home" : "/dashboard";

  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <Route
      {...rest}
      render={(props) =>
        isLogin() && !isPublic ? <Redirect to={url} /> : <Component {...props} />
      }
    />
  );
};

export default PublicRoute;
